/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Llm_Settings_Update_ErrorInputs */



/**
* | output |
* | --- |
* | "Error updating LLM settings." |
*
* @param {Compliance_Llm_Settings_Update_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_llm_settings_update_error = /** @type {((inputs?: Compliance_Llm_Settings_Update_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Llm_Settings_Update_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Aktualisieren der LLM-Einstellungen.")
	return /** @type {LocalizedString} */ ("Error updating LLM settings.")
});